import React, { useEffect } from "react"
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode"
import FormWebinar from '../form-webinar/form-webinar';
import AboutContent from '../../../shared/components/molecules/about-content/about-content'
import Talks from '../../molecules/talks-conferences/talks-conferences'
import MainBanner from "../../molecules/main-banner/main-banner"
import TabsSubHeader from "../../molecules/tabs-sub-header/tabs-sub-header"
import WebinarService from "../../../shared/services/webinar";
import "./next-event-content.scss"

const nextEventContent = props => {
    const webinarInfo = props.webinarInfo
    const { isMobile } = props
    const { homeLink } = useHomeLinkMode()

    useEffect(() => {
        let payload = {
            cmsId: webinarInfo.identificadorEvento,
            typeContent: "CONFERENCIA"
        }

        WebinarService.postView(payload).then(res => {
            if (res.status !== 200) {
                console.log("Error registro vista", error)
            }
        }).catch(error => {
            console.log("Error registro vista", error)
        })

    }, [])

    return (
        <div className="f-event">
            <div className="f-event-content">
                <MainBanner
                    webinarInfo={webinarInfo}
                    isMobile={isMobile}
                    isCompleted={false}
                    homeLink={homeLink}
                    isSecondStyle={true}
                />

                <TabsSubHeader
                    isSecondStyle={true}
                    isMobile={isMobile}
                />
                
                <div id="inscripcion" className="f-event-content__inscription">
                    <FormWebinar
                        identificadorEvento={webinarInfo.identificadorEvento}
                        redireccionWhatsApp={webinarInfo.redireccionWhatsApp}
                        profesiones={[]}
                        redireccionWebinar={webinarInfo.redireccionWebinar}
                        isWomenWebinar={false}
                        isSecondStyle={true}
                        currentStep="index"
                        isMobile={isMobile}
                        webinarName={webinarInfo.bannerPrincipal ? webinarInfo.bannerPrincipal[0]?.nombre : "HOLA"}
                        webinarStatus={webinarInfo.estadoWebinar}
                        slug={webinarInfo.slug}
                        informacionDescargaExitosa={webinarInfo.informacionDescargaExitosa}
                        informacionInicioConferencia={webinarInfo.informacionInicioConferencia}
                        informacionInscripcionConferencia={webinarInfo.informacionInscripcionConferencia}
                        informacionInscripcionExitosa={webinarInfo.informacionInscripcionExitosa}
                        informacionSolicitudCertificado={webinarInfo.informacionSolicitudCertificado}
                        checksAceptoDePoliticas={webinarInfo.checksAceptoDePoliticas}
                    />
                </div>

                <AboutContent data={webinarInfo} isSecondStyle={true} />

                <Talks
                    talksInfo={webinarInfo.referenciasDeConferencistasLecciones}
                    webinarInfo={webinarInfo}
                    isMobile={isMobile}
                    isCompleted={false}
                    isSecondStyle={true}
                />
            </div>
        </div>
    )
}

export default nextEventContent
